
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marketing-partners",
      function () {
        return require("private-next-pages/marketing-partners.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/marketing-partners"])
      });
    }
  